import {
  gql 
} from "@apollo/client";

export const ADD_WARRANTY_INFO = gql`
    mutation addWarrantyInfo(
        $email: String!
        $firstname: String
        $lastname: String
        $phone: String
        $gender: Int
        $website: Int
        $which_buy: String
        $increment_id: String
        $platform: String
    ) {
        addWarrantyInfo(
            input: {
                email: $email
                firstname: $firstname
                lastname: $lastname
                phone: $phone
                gender: $gender
                website: $website
                which_buy: $which_buy
                increment_id: $increment_id
                platform: $platform
            }
        ) {
            code
            message
            content
        }
    }
`;

export default {
  addWarrantyInfoMutation: ADD_WARRANTY_INFO
};
